import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '@/i18n/LanguageProvider';

const categories = [
  { id: 'all', label: 'Tutti' },
  { id: 'Residenziale', label: 'Residenziale' },
  { id: 'Commerciale', label: 'Commerciale' },
  { id: 'In Progress', label: 'In Progress' },
  { id: 'Outdoor', label: 'Outdoor' }
];

export default function ProjectFilter({ activeCategory, onCategoryChange }) {
  const { t } = useLanguage();
  return (
    <div className="-mx-2 flex overflow-x-auto px-2 pb-1 md:mx-0 md:flex-wrap md:gap-8 md:px-0">
      {categories.map((category) => (
        <button
          key={category.id}
          onClick={() => onCategoryChange(category.id)}
          aria-pressed={activeCategory === category.id}
          className={`relative min-h-11 flex-none px-3 pb-2 text-xs font-light uppercase tracking-widest-custom transition-colors duration-300 md:px-0 ${
              activeCategory === category.id ? 'text-[#2d2d2d]' : 'text-[#7a7a7a] hover:text-[#2d2d2d]'
            }`}
        >
          {t(category.label)}
          {activeCategory === category.id && (
            <motion.div
              layoutId="activeFilter"
              className="absolute bottom-0 left-0 right-0 h-px bg-[#2d2d2d]"
              transition={{ type: 'spring', stiffness: 500, damping: 30 }}
            />
          )}
        </button>
      ))}
    </div>
  );
}